import Vue from 'vue'

export default function setTestToLesson({ lesson_id, group_id, test_id }) {
    const proxy = process.env.VUE_APP_PROXY
    const api_uri = process.env.VUE_APP_API_URI

    let url = proxy + api_uri + "/tests/" + test_id + "/results"
    return Vue.http
        .post(url, { lesson_id, group_id }, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json()).catch(() => { throw "Ошибка сохранения" })
}